module.exports = __webpack_public_path__ + "img/icon-bg5.ea2ef722.png";